import React, { useEffect, useState } from 'react';
import {
  Box,
  Typography,
  CircularProgress,
  Alert,
  Stepper,
  Step,
  StepLabel,
} from '@mui/material';
import { CoordinationStatus } from '~/types/coordinate';

interface Props {
  coordinationStatus: CoordinationStatus;
  selectedProviderName?: string;
}

const steps = ['Confirming availability', 'Assembling referral packet'];

const CommitConfirmFlow: React.FC<Props> = ({ coordinationStatus, selectedProviderName }) => {
  const [activeStep, setActiveStep] = useState(0);

  useEffect(() => {
    if (coordinationStatus !== 'confirming') {
      setActiveStep(0);
      return;
    }
    setActiveStep(0);
    const t = setTimeout(() => setActiveStep(1), 1000);
    return () => clearTimeout(t);
  }, [coordinationStatus]);

  if (coordinationStatus === 'confirming') {
    return (
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          minHeight: 200,
          gap: 3,
        }}
      >
        <CircularProgress size={36} />
        <Stepper activeStep={activeStep} alternativeLabel sx={{ width: '100%', maxWidth: 400 }}>
          {steps.map(label => (
            <Step key={label}>
              <StepLabel>{label}</StepLabel>
            </Step>
          ))}
        </Stepper>
        <Typography variant="body2" color="text.secondary">
          {activeStep === 0
            ? `Checking ${selectedProviderName ?? 'provider'} availability…`
            : 'Assembling referral packet…'}
        </Typography>
      </Box>
    );
  }

  if (coordinationStatus === 'confirm_failed') {
    return (
      <Alert severity="warning" sx={{ mb: 2 }}>
        <Typography variant="body2" fontWeight={600}>
          {selectedProviderName ?? 'Provider'} is currently unavailable.
        </Typography>
        <Typography variant="body2">
          Select another provider from the list below or run matching again.
        </Typography>
      </Alert>
    );
  }

  return null;
};

export default CommitConfirmFlow;
